import { render } from "./TemplateElementsPreviewImage.vue?vue&type=template&id=6593e4d2&scoped=true"
import script from "./TemplateElementsPreviewImage.vue?vue&type=script&lang=ts"
export * from "./TemplateElementsPreviewImage.vue?vue&type=script&lang=ts"

import "./TemplateElementsPreviewImage.vue?vue&type=style&index=0&id=6593e4d2&lang=scss&scoped=true"
import "./TemplateElementsPreviewImage.vue?vue&type=style&index=1&id=6593e4d2&lang=scss"
script.render = render
script.__scopeId = "data-v-6593e4d2"

export default script